// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".regions-filter input{width:0 !important;height:0 !important}", "",{"version":3,"sources":["webpack://./app/components/RegionsFilter/styles.scss"],"names":[],"mappings":"AACE,sBACE,kBAAA,CACA,mBAAA","sourcesContent":[".regions-filter {\r\n  input {\r\n    width: 0 !important;\r\n    height: 0 !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
